import * as XLSX from 'xlsx';

export const exportTable = (titles, data, docName = 'export') =>{
    const rows = [
    titles,
    ...data,
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, docName);

    XLSX.writeFile(workbook, `${docName}.xlsx`);
}